// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-section .van-popup__close-icon{font-size:.32rem;color:#fff;top:5%;right:3%}", ""]);
// Exports
module.exports = exports;
